/**
 * @class AssetUnloader
 * @description  unload assets from cache
 *
 */
export class AssetUnloader {}

/**
 * @description unload a texture from cache
 * @param {Phaser.Scene} scene scene with texture cache
 * @param {String} key key of texture to unload
 */
AssetUnloader.UnloadTexture = (scene, key) => {
  if (scene.textures.exists(key)) {
    scene.textures.remove(key);
  }
};

/**
 * @description unload a spritesheet from cache
 * @param {Phaser.Scene} scene scene with texture cache
 * @param {String} key key of texture to unload
 */
AssetUnloader.UnloadMultiAtlas = (scene, key) => {
  if (scene.textures.exists(key)) {
    scene.textures.remove(key);
  }
  if (scene.cache.json.exists(key)) {
    scene.cache.json.remove(key);
  }
};

/**
 * @description unload a json file from cache
 * @param {Phaser.Scene} scene scene with texture cache
 * @param {String} key key of texture to unload
 */
AssetUnloader.UnloadJSON = (scene, key) => {
  if (scene.cache.json.exists(key)) {
    scene.cache.json.remove(key);
  }
};

/**
 * @description unload a spine file from cache
 * @param {Phaser.Scene} scene scene with texture cache
 * @param {String} key key of texture to unload
 */
AssetUnloader.UnloadSpine = (scene, key) => {
  if (scene.cache.custom.spineTextures.exists(key)) {
    let spineTextures = scene.cache.custom.spineTextures.get(key);
    for (let i = 0; i < spineTextures.pages.length; i++) {
      scene.textures.remove(spineTextures.pages[i].name);
      spineTextures.pages[i].texture.dispose();
    }
    scene.cache.custom.spineTextures.remove(key);
    spineTextures = null;
  }

  let spinedata = scene.cache.custom.spine.get(key)?.data;
  if (spinedata) {
    let textures = spinedata.split('\n');
    for (let t = 0; t < textures.length; t++) {
      if (textures[t].includes('.png'))
        AssetUnloader.UnloadTexture(scene, textures[t].split('.')[0] + '.png');
    }
    textures = null;
  }
  spinedata = null;

  if (scene.cache.custom.spine.exists(key)) scene.cache.custom.spine.remove(key);

  AssetUnloader.UnloadJSON(scene, key);
};

/**
 * @description unload an audio sprite file from cache
 * @param {Phaser.Scene} scene scene with texture cache
 * @param {String} key key of texture to unload
 */
AssetUnloader.UnloadAudioSprite = (scene, key) => {
  if (scene.cache.audio.exists(key)) {
    if (scene.game) {
      scene.game.sound.removeByKey(key);
    }
    scene.cache.audio.remove(key);
    scene.cache.json.remove(key);
  }
};

/**
 * @description unload an assetpack file from cache
 * @param {Phaser.Scene} scene scene with texture cache
 * @param {object} assetpack asset pack to unload
 * @param {String[]} keys array of keys to unload from pack, if not supplied all pack will be unloaded
 */
AssetUnloader.UnloadAssetpack = (scene, assetpack, keys) => {
  keys = keys || Object.keys(assetpack);
  keys.forEach((key) => {
    if (assetpack[key]) {
      assetpack[key].files.forEach((file) => {
        switch (file.type.toLowerCase()) {
          case 'image':
          case 'texture':
            AssetUnloader.UnloadTexture(scene, file.key);
            break;
          case 'atlas':
          case 'multiatlas':
            AssetUnloader.UnloadMultiAtlas(scene, file.key);
            break;
          case 'spine':
            AssetUnloader.UnloadSpine(scene, file.key);
            break;
          case 'json':
            AssetUnloader.UnloadJSON(scene, file.key);
            break;
          case 'audio':
          case 'audiosprite':
            AssetUnloader.UnloadAudioSprite(scene, file.key);
            break;
        }
      });
    }
  });
};
